import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Temporarily remove StrictMode to test
createRoot(document.getElementById('root')).render(
  <App />
)
